import ActionTypes from "../constants/ActionTypes";

const initialState = () => {
    const cartLocalStorage = window.localStorage.getItem("cart")
        ? JSON.parse(window.localStorage.getItem("cart"))
        : {};
    return {
        clubQuickRegistration: {},
        ticketItems: [],
        ...cartLocalStorage,
        shippingStepComplete: false,
        detailsStepComplete: false,
        loading: false,
        error: null,
    };
};

const cartReducer = (state = initialState(), action) => {
    const newItems = action?.cart?.items
        ?.map(({ key }) => key)
        .filter(key => !state.items?.map(({ key }) => key).includes(key));
    switch (action.type) {
        case ActionTypes.NEW_LOGIN:
            return {
                ...state,
                clubQuickRegistration: {},
            };
        case ActionTypes.GET_CART_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.GET_CART_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.cart,
                ticketItems: action.cart.items
                    .filter(
                        item => item?.item_data?.[0]?.free_text_label != null
                    )
                    .map(item => item.key),
            };
        case ActionTypes.GET_CART_FAIL:
            return {
                ...state,
                loading: false,
            };
        case ActionTypes.CLEAR_CART:
            window.localStorage.removeItem("cart");

            return {
                loading: false,
                ...initialState(),
                clubQuickRegistration:
                    state.clubQuickRegistration &&
                    state.clubQuickRegistration.remember
                        ? {
                              ...state.clubQuickRegistration,
                              clubUrl: undefined,
                              cartItemId: undefined,
                          }
                        : {},
            };
        case ActionTypes.ADD_TO_CART_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.ADD_TO_CART_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.cart,
                cartItemUrls: action.cartItemUrls,
                ticketItems: action.isTicketItem
                    ? [...state.ticketItems, ...newItems]
                    : state.ticketItems,
            };
        case ActionTypes.ADD_TO_CART_FAIL:
            return {
                ...state,
                loading: false,
            };
        case ActionTypes.QUICK_REG_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.QUICK_REG_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.cart,
                clubQuickRegistration: {
                    ...action.clubQuickRegistration,
                    cartItemId: newItems[0],
                },
            };
        case ActionTypes.QUICK_REG_FAIL:
            return {
                ...state,
                loading: false,
            };
        case ActionTypes.REMOVE_FROM_CART_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.REMOVE_FROM_CART_SUCCESS:
            const removedItems = state.items
                ?.map(({ key }) => key)
                .filter(
                    key =>
                        !action.cart.items.map(({ key }) => key).includes(key)
                );

            return {
                ...state,
                loading: false,
                ...action.cart,
                ticketItems: state.ticketItems.filter(
                    key => !removedItems.includes(key)
                ),
                clubQuickRegistration: removedItems.includes(
                    state.clubQuickRegistration.cartItemId
                )
                    ? state.clubQuickRegistration &&
                      state.clubQuickRegistration.remember
                        ? {
                              ...state.clubQuickRegistration,
                              clubUrl: undefined,
                              cartItemId: undefined,
                          }
                        : {}
                    : state.clubQuickRegistration,
            };
        case ActionTypes.REMOVE_FROM_CART_FAIL:
            return {
                ...state,
                loading: false,
            };
        case ActionTypes.APPLY_PROMO_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.APPLY_PROMO_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.cart,
            };
        case ActionTypes.APPLY_PROMO_FAIL:
            return {
                ...state,
                loading: false,
                coupons: [],
            };
        case ActionTypes.SELECT_SHIPPING_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.SELECT_SHIPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.cart,
                shippingStepComplete: action.shippingStepComplete,
            };
        case ActionTypes.SELECT_SHIPPING_FAIL:
            return {
                ...state,
                loading: false,
                shippingStepComplete: false,
            };
        case ActionTypes.UPDATE_CUSTOMER_CART_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.UPDATE_CUSTOMER_CART_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.cart,
                detailsStepComplete: true,
            };
        case ActionTypes.UPDATE_CUSTOMER_CART_FAIL:
            return {
                ...state,
                loading: false,
                detailsStepComplete: false,
            };
        case ActionTypes.GET_PAYMENT_OPTIONS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ActionTypes.GET_PAYMENT_OPTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                paymentOptions: action.paymentOptions,
            };
        case ActionTypes.GET_PAYMENT_OPTIONS_FAIL:
            return {
                ...state,
                loading: false,
            };
        case ActionTypes.RESET_CHECKOUT_STEP:
            return {
                ...state,
                [action.name]: false,
            };
        case ActionTypes.SET_SAME_BILLING_DETAILS:
            return {
                ...state,
                useDifferentBillingDetails: action.useDifferentBillingDetails,
            };
        default:
            return state;
    }
};

export default cartReducer;
